"use client";

import Link from "next/link";
import { Button } from "../ui";
import { ArrowRight, Play } from "lucide-react";

const Hero = () => {
  return (
    <section className="py-24 text-center">
      <div className="container">
        <div className="mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold tracking-tight sm:text-6xl">
            Transform Your Workflow
            <span className="block bg-hero-gradient bg-clip-text text-transparent">
              With Intelligent Solutions
            </span>
          </h1>
          <p className="mt-6 text-lg leading-8 text-muted-foreground max-w-2xl mx-auto">
            Streamline your processes, boost productivity, and scale your business 
            with our comprehensive platform designed for modern teams.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button asChild size="lg" className="hero-gradient text-white border-0 hover:opacity-90 transition-opacity">
              <Link href="/client/start">
                Get Started
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button variant="outline" size="lg">
              <Play className="mr-2 h-4 w-4" />
              Watch Demo
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
